<template>
	<v-row v-if="acuPoints.length > 0" no-gutters class="my-4" align="center">
		<v-col cols="12" md="12">
			<v-row no-gutters>
				<v-col :style="col1Style">
					<p v-if="auricular" class="text-center text--disabled" v-translate>Right</p>
					<v-row no-gutters align="center" justify="center">
						<v-col md="auto">
							<AcuPointList :list="quadrantOneClassic" @remove-point="removePoint" :grid="true" :edit="edit" />
						</v-col>
						<v-col class="px-2" md="auto">
							<AcuPointList :list="quadrantOneTung" @remove-point="removePoint" :grid="true" :edit="edit" />
						</v-col>
					</v-row>
				</v-col>
				<v-col cols="3" v-if="quadrantFive.length > 0 || quadrantSix.length > 0">
					<v-row no-gutters style="height:100%" align="end">
						<v-col cols="12" class="flex-grow-1">
							<v-row no-gutters style="min-height: 34px">
								<v-col cols="6" style="border-right: 1px solid gray;"></v-col>
								<v-col cols="6"></v-col>
							</v-row>
						</v-col>
						<v-col cols="12">
							<v-row no-gutters justify="center" style="border-top: 1px solid gray; border-left: 1px solid gray; border-right: 1px solid gray">
								<v-col md="auto">
									<AcuPointList :list="quadrantFiveClassic" @remove-point="removePoint" :grid="true" :edit="edit" />
								</v-col>
								<v-col class="px-2" md="auto">
									<AcuPointList :list="quadrantFiveTung" @remove-point="removePoint" :grid="true" :edit="edit" />
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-col>
				<v-col :style="colStyle">
					<p v-if="auricular" class="text-center text--disabled" v-translate>Left</p>
					<v-row no-gutters align="center" justify="center">
						<v-col md="auto">
							<AcuPointList :list="quadrantTwoClassic" @remove-point="removePoint" :grid="true" :edit="edit" />
						</v-col>
						<v-col class="px-2" md="auto">
							<AcuPointList :list="quadrantTwoTung" @remove-point="removePoint" :grid="true" :edit="edit" />
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-col>
		<v-col v-if="!auricular" cols="12" md="12">
			<v-row no-gutters>
				<v-col :style="!(quadrantFive.length > 0 || quadrantSix.length > 0) ? 'border-right: 1px solid gray' : ''">
					<v-row no-gutters align="center" justify="center">
						<v-col md="auto">
							<AcuPointList :list="quadrantThreeClassic" @remove-point="removePoint" :grid="true" :edit="edit" />
						</v-col>
						<v-col class="px-2" md="auto">
							<AcuPointList :list="quadrantThreeTung" @remove-point="removePoint" :grid="true" :edit="edit" />
						</v-col>
					</v-row>
				</v-col>
				<v-col cols="3" v-if="quadrantFive.length > 0 || quadrantSix.length > 0">
					<v-row no-gutters align="center" justify="center" style="border-bottom: 1px solid gray; border-left: 1px solid gray; border-right: 1px solid gray;">
						<v-col md="auto">
							<AcuPointList :list="quadrantSixClassic" @remove-point="removePoint" :grid="true" :edit="edit" />
						</v-col>
						<v-col class="px-2" md="auto">
							<AcuPointList :list="quadrantSixTung" @remove-point="removePoint" :grid="true" :edit="edit" />
						</v-col>
					</v-row>
					<v-col cols="12" class="pa-0">
						<v-row no-gutters style="min-height: 34px">
							<v-col cols="6" style="border-right: 1px solid gray;"></v-col>
							<v-col cols="6"></v-col>
						</v-row>
					</v-col>
				</v-col>
				<v-col>
					<v-row no-gutters align="center" justify="center">
						<v-col md="auto">
							<AcuPointList :list="quadrantFourClassic" @remove-point="removePoint" :grid="true" :edit="edit" />
						</v-col>
						<v-col class="px-2" md="auto">
							<AcuPointList :list="quadrantFourTung" @remove-point="removePoint" :grid="true" :edit="edit" />
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
import AcuPointList from "@/components/acupuncture/AcuPointList.vue";

export default {
	name: "AcupunctureGrid",
	props: {
		acuPoints: {},
		edit: {
			default: true
		},
		auricular: {
			default: false
		}
	},
  components: {
    AcuPointList
  },
  data: () => ({}),
  computed: {
    quadrantOne() {
			return this.acuPoints.filter(point => this.$store.getters.acuPointQuadrant(point) == 1).sort((a, b) => {
				return ('' + a.name).localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'});
			});
		},
		quadrantOneClassic() {
			return this.quadrantOne.filter(point => !point.tung);
		},
		quadrantOneTung() {
			return this.quadrantOne.filter(point => point.tung);
		},
		quadrantTwo() {
			return this.acuPoints.filter(point => this.$store.getters.acuPointQuadrant(point) == 2).sort((a, b) => {
				return ('' + a.name).localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'});
			});
		},
		quadrantTwoClassic() {
			return this.quadrantTwo.filter(point => !point.tung);
		},
		quadrantTwoTung() {
			return this.quadrantTwo.filter(point => point.tung);
		},
		quadrantThree() {
			return this.acuPoints.filter(point => this.$store.getters.acuPointQuadrant(point) == 3).sort((a, b) => {
				return ('' + a.name).localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'});
			});
		},
		quadrantThreeClassic() {
			return this.quadrantThree.filter(point => !point.tung);
		},
		quadrantThreeTung() {
			return this.quadrantThree.filter(point => point.tung);
		},
		quadrantFour() {
			return this.acuPoints.filter(point => this.$store.getters.acuPointQuadrant(point) == 4).sort((a, b) => {
				return ('' + a.name).localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'});
			});
		},
		quadrantFourClassic() {
			return this.quadrantFour.filter(point => !point.tung);
		},
		quadrantFourTung() {
			return this.quadrantFour.filter(point => point.tung);
		},
		quadrantFive() {
			return this.acuPoints.filter(point => this.$store.getters.acuPointQuadrant(point) == 5).sort((a, b) => {
				return ('' + a.name).localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'});
			});
		},
		quadrantFiveClassic() {
			return this.quadrantFive.filter(point => !point.tung);
		},
		quadrantFiveTung() {
			return this.quadrantFive.filter(point => point.tung);
		},
		quadrantSix() {
			return this.acuPoints.filter(point => this.$store.getters.acuPointQuadrant(point) == 6).sort((a, b) => {
				return ('' + a.name).localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'});
			});
		},
		quadrantSixClassic() {
			return this.quadrantSix.filter(point => !point.tung);
		},
		quadrantSixTung() {
			return this.quadrantSix.filter(point => point.tung);
		},
		colStyle() {
			let style = "";
			if(!this.auricular) style = style + 'border-bottom: 1px solid gray;';
			//if(this.quadrantFive.length > 0 || this.quadrantSix.length > 0) style = style + 'border-left: 1px solid gray;';
			return style;
		},
		col1Style() {
			let style = "";
			if(!this.auricular) style = style + 'border-bottom: 1px solid gray;';
			if(!(this.quadrantFive.length > 0 || this.quadrantSix.length > 0)) style = style + 'border-right: 1px solid gray;';
			return style;
		}
  },
  methods: {
    removePoint(point) {
      this.$emit('remove-point', point);
    }
  }
}
</script>